module.exports = __webpack_public_path__ + "img/image.705bfeaf.png";